import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  ButtonGroup,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Card,
  CardContent,
  Divider,
  Avatar,
  Chip,
  IconButton,
  Tooltip,
  Popover,
  CircularProgress,
  InputAdornment,
  InputLabel,
  FormControl,
  FormHelperText,
  Input,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  AccountBalance,
  ArrowForwardIos,
  CheckCircle,
  Group,
  Block,
  AccountCircle,
  Close,
  Edit,
  AccountBalanceWallet,
  Delete,
  Assignment,
  VpnLock,
  Money,
  Schedule,
  CallMade,
  CallReceived,
  Business,
  AcUnit,
  DateRange,
  TabUnselected,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MaskedInput from "react-text-mask";

import MUIDataTable from "mui-datatables";
import Format from "date-fns/format";

import { makeStyles } from "@material-ui/styles";
import { Skeleton } from "@material-ui/lab";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { useSnackbar } from "notistack";
import { v4 as uuidv4 } from "uuid";

import UserInfo from './login_info'

import safaribus from "../../assets/img/logo_primary.svg";
import LogoWhite from "../../assets/img/logo_white.svg";

import {
  TransportService,
  AdminService,
  FinanceService,
  ReportingService,
  Validator,
} from "../../utils/web_config.jsx";
import { OutlinedInput } from "@material-ui/core";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginLeft: 250,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      paddingTop: 10,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  content: {
    height: 250,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: 10,
  },
  action: {
    borderRadius: 10,
  },
  card: {
    borderRadius: 10,
  },

}));


function WalletDetails(props) {
  const classes = useStyles();
  const history = useHistory();

  const ag = localStorage.getItem("nx_ag");

  const [accountData, setAccountData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [selectedAccount, setSelectedAccount] = useState({
    saving: false,
    loading: false,
    toggling: false,
    data: {},
  });



  const [from, setFrom] = useState({
    value: new Date(),
    error: "",
  });
  const [to, setTo] = useState({
    value: new Date(),
    error: "",
  });
  const [range, setRange] = useState({ index: 0, acnhor: null });


  const [transactions, setTransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading account transactions....",
    loading: false,
    toggling: false,
    data: [],
  });


  const [agentTopup, setAgentTopup] = useState({
    saving: false,
    loading: false,
    open:false
  });

  const [topupReference, setReference] = useState({ value: "", error: "" });
  const [topupAmount, setAmount] = useState({ value: "", error: "" });


  useEffect(() => {
    var accountData =JSON.parse(ag);
    setAccountData(accountData);

    setSelectedAccount({
      ...selectedAccount,
      data: history.location.state,
    });
    getAccountDetails(accountData.token, history.location.state.agent_code);
    getTransactions(
      accountData.token,
      history.location.state.agent_code,
      from.value,
      to.value
    );
  }, []);

  ///////////////////////////////////
  //////////
  const transactionsColums = [
    {
      name: "tx_type_name",
      label: "Transaction type",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "channel_type",
      label: "Channel",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "credited_account",
      label: "To account",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    // {
    //   name: "total_commission_amount",
    //   label: "Commission",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value) => (
    //       <span>{new Validator().formatMoney(value)}</span>
    //     ),
    //   },
    // },
    {
      name: "tx_date",
      label: "Date",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tx_time",
      label: "Time",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "mine",
      label: "Mine",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <>
              {transactions.data[dataI].debited_account ==
              selectedAccount.data.account?.code ? (
                <CallMade color="inherit" />
              ) : (
                <CallReceived color="primary" />
              )}
            </>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {["completed", "confirmed"].includes(
                    transactions.data[dataI].status.toLowerCase()
                  ) ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                transactions.data[dataI].status.toLowerCase() == "completed"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(transactions.data[dataI].status)}
            />
          );
        },
      },
    },
  ];

  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search transaction...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    onCellClick: (cellData, cellMeta) => {
      var tr = transactions.data[cellMeta.dataIndex];
      // history.push("/centrika/agents/details/viewTransaction", tr);
    },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
  };
  /////////////////////
  const notify = (variant, msg, status) => {
 
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  //////////////

  const onFromChange = (date) => {
    setFrom({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(
      accountData.token,
      history.location.state.agent_code,
      date,
      to.value
    );
  };
  const onToChange = (date) => {
    setTo({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(
      accountData.token,
      history.location.state.agent_code,
      from.value,
      date
    );
  };

  /////////////////////////

  const onReferenceChange = (event) => {
    
      setReference({ value: event.target.value, error: "" });
    
  };
  const onAmountChange = (event) => {
    if (event.target.value === "") {
      setAmount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.topup_amount")
            }
          </Translate>
        ),
      });
    } else {
      setAmount({ value: event.target.value, error: "" });
    }
  };
  ////////////////////////

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  /////////////////////////////////////////////////

  const getAccountDetails = (token, acc) => {
    const agentsInstance = axios.create(new AdminService().getHeaders(token));

    setSelectedAccount({ ...selectedAccount, loading: true });

    agentsInstance
      .get(new FinanceService().GET_AGENT_PROFILE + acc)
      .then(function (response) {
        const d = response.data;
        setSelectedAccount({ ...selectedAccount, loading: false, data: d.data });
      })
      .catch(function (error) {
        setSelectedAccount({ ...selectedAccount, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(
          error?.response?.status == 404 ? "info" : "error",
          e,
          error?.response?.status
        );
      });
  };

  ///////////////////////////////////

  const getTransactions = (token, acc, fromDate, toDate) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setTransactions({ ...transactions, loading: true });

    console.log("getting transactions .....");

    usersInstance
      .get(
        new FinanceService().GET_AGENT_TRANSACTIONS +acc+
          "?per_page=5000&start_date=" +
          Format(fromDate, ["yyyy-MM-dd"]) +
          "&end_date=" +
          Format(toDate, ["yyyy-MM-dd"])
      )
      .then(function (response) {
        setTransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setTransactions({
            ...transactions,
            status: "There are no transactions available for this account",
          });
        } else {
          var groups = new Validator().groupArrayOfObjects(
            d.data,
            "tx_type_name"
          );
          var keys = Object.keys(groups);
          setTransactions({
            ...transactions,
            data: d.data,
            allData: d.data,
            keys: keys,
            groups: groups,
          });
        }
      })
      .catch(function (error) {
        setTransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setTransactions({ ...transactions, status: e });

        notify(
          error?.response?.status == 404 ? "info" : "error",
          e,
          error?.response?.status
        );
      });
  };



  /////////////////////////////////////////////////

    ////////////////////

    const onTopupClick = () => {

 if (topupAmount.value === "") {
        setAmount({
          value: "",
          error: (
            <Translate>
              {({ translate }) =>
                translate("agent_details.forms.hints.topup_amount")
              }
            </Translate>
          ),
        });
      } else {
        setAgentTopup({ ...agentTopup, open2: true })
      }
    };
  //////////////////

  const doTopup = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAgentTopup({ ...agentTopup, saving: true,open2:false });

    const data={
      channel_type: "WEB",
      agent_code:  new UserInfo().CODE,
      dest_agent_code:  history.location.state.agent_code,
      reference_number: topupReference.value==""?uuidv4():topupReference.value,
      amount: topupAmount.value
    }

    createInstance
      .post(new FinanceService().FLOAT_ALLOCATION, data)
      .then(function (response) {
        var d = response.data;


        setAgentTopup({ ...agentTopup, saving: false, open: false,open2:false });
        notify("success", "Float allocation successfull");
        
        getAccountDetails(accountData.token, history.location.state.agent_code);
        getTransactions(accountData.token, history.location.state.agent_code, from.value, to.value);
      })
      .catch(function (error) {
        setAgentTopup({ ...agentTopup, saving: false ,open2:false});
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>

                 {/* //////////////////////// */}


                 <Dialog
          open={agentTopup.open2}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => setAgentTopup({ ...agentTopup, open2: false })}
        >
          <DialogTitle id="alert-dialog-title">{"Float allocation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You are about to allocate <b>{topupAmount.value} RWF</b> float to this agent manager, click the button below to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setAgentTopup({ ...agentTopup, open2: false })
              }}
              color="primary"
              variant='outlined'
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
              doTopup()
              }}
              color="primary"
              autoFocus
              disableElevation
              disabled={agentTopup.saving}
              variant='contained'
            >
               {agentTopup.saving ? <CircularProgress size={25} /> : "Confirm"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* //////////// */}
        <Popover
          id={"pop-id"}
          open={range.acnhor != null}
          anchorEl={range.acnhor}
          onClose={() => setRange({ ...range, acnhor: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          elevation={4}
        >
          <Box p={2}>
            <Typography color="textSecondary">Select date range</Typography>
            <Box mt={2} mb={2}>
              <Box>
                <DatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  maxDate={to.value}
                  autoOk
                  label={<Translate id="reports.forms.labels.from" />}
                  value={from.value}
                  inputVariant="outlined"
                  onChange={onFromChange}
                  InputProps={{
                    disableUnderline: true,
                    style: { paddingRight: 0 },
                  }}
                />
              </Box>
              <Box>
                <DatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  maxDate={new Date()}
                  minDate={from.value}
                  autoOk
                  label={<Translate id="reports.forms.labels.to" />}
                  value={to.value}
                  inputVariant="outlined"
                  onChange={onToChange}
                  InputProps={{
                    disableUnderline: true,
                    style: { paddingRight: 0 },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Popover>

        {/* ----------------------------               confirm dialogn    ------------------------------- */}

        <Dialog
          open={agentTopup.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => setAgentTopup({ ...agentTopup, open: false })}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="alert-dialog-title">{"Float allocation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Allocate float to this agent
            </DialogContentText>

            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={topupReference.value}
                    placeholder={translate(
                      "agent_details.forms.hints.topup_reference"
                    )}
                    label={
                      <Translate id="agent_details.forms.labels.topup_reference" />
                    }
                    fullWidth
                    onChange={onReferenceChange}
                    helperText={topupReference.error}
                    error={topupReference.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={topupAmount.value}
                    placeholder={translate(
                      "agent_details.forms.hints.topup_amount"
                    )}
                    label={
                      <Translate id="agent_details.forms.labels.topup_amount" />
                    }
                    fullWidth
                    onChange={onAmountChange}
                    helperText={topupAmount.error}
                    error={topupAmount.error !== ""}
                  />
                )}
              </Translate>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => setAgentTopup({ ...agentTopup, open: false })}
              color="primary"
            >
              <Translate id="agent_details.forms.buttons.cancel" />
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onTopupClick()}
              autoFocus
              disableElevation
              disabled={agentTopup.saving}
            >
              {agentTopup.saving ? <CircularProgress size={25} /> : "Send float"}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Dialogs ends here */}

        <Box mt={3} />
        <Container>
          <Box display="flex" alignItems="center">
            <Box mr={2}>
              {" "}
              <AccountBalance color="primary" fontSize="large" />
            </Box>
            <Box flexGrow={1} display="flex" alignItems="center">
              <Typography variant="h5">
                <b>{selectedAccount.data.name}</b>
              </Typography>
            </Box>

            <Box display="flex" mr={2} alignItems="center">
              <Box mr={2}>
                <ButtonGroup color="primary" disableElevation>
                  <Button
                    className={classes.btn}
                    variant={range.index == 0 ? "contained" : "outlined"}
                    onClick={() => {
                      setRange({ index: 0 });
                      var date1 = new Date();
                      var date2 = new Date();

                      setFrom({ value: date1 });
                      setTo({ value: date2 });
                      getTransactions(
                        accountData.token,
                        history.location.state.agent_code,
                        date1,
                        date2
                      );
                    }}
                  >
                    Today
                  </Button>
                  <Button
                    className={classes.btn}
                    variant={range.index == 1 ? "contained" : "outlined"}
                    onClick={() => {
                      setRange({ index: 1 });
                      var date1 = new Date();
                      date1.setDate(date1.getDate() - 7);
                      var date2 = new Date();

                      setFrom({ value: date1 });
                      setTo({ value: date2 });
                      getTransactions(
                        accountData.token,
                        history.location.state?.agent_code,
                        date1,
                        date2
                      );
                    }}
                  >
                    Last week
                  </Button>
                  <Button
                    className={classes.btn}
                    variant={range.index == 2 ? "contained" : "outlined"}
                    onClick={() => {
                      setRange({ index: 2 });
                      var date1 = new Date();
                      date1.setDate(date1.getDate() - 30);
                      var date2 = new Date();

                      setFrom({ value: date1 });
                      setTo({ value: date2 });
                      getTransactions(
                        accountData.token,
                        history.location.state.agent_code,
                        date1,
                        date2
                      );
                    }}
                  >
                    Last month
                  </Button>
                </ButtonGroup>
              </Box>

              <IconButton
                color="primary"
                onClick={(e) => setRange({ ...range, acnhor: e.currentTarget })}
              >
                <DateRange />
              </IconButton>
            </Box>
          </Box>
          <Box mt={3} />
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4}>
              <List>
                {selectedAccount.loading ? (
                  [1, 2, 3, 4, 5].map((item, i) => (
                    <ListItem key={i}>
                      <ListItemText
                        primary={
                          <Skeleton
                            variant="text"
                            width={"100%"}
                            style={{ borderRadius: 7 }}
                          />
                        }
                      />
                    </ListItem>
                  ))
                ) : (
                  <>
                    <ListItem>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() =>  setAgentTopup({ ...agentTopup, open: true })}
                      >
                       Allocate float
                      </Button>
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary="Agent name"
                        secondary={selectedAccount.data?.account?.account_name}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          selectedAccount.data?.account?.device_id != null
                            ? "Device ID"
                            : "Phone number"
                        }
                        secondary={selectedAccount?.account?.data.phone_number}
                      />
                    </ListItem>
                    {selectedAccount.data?.account?.wallet_id != null && (
                      <ListItem>
                        <ListItemText
                          primary="Serial number"
                          secondary={selectedAccount.data?.account?.serial_number??'None'}
                        />
                      </ListItem>
                    )}

                    <Divider variant="middle" />
                    <ListItem>
                      <ListItemIcon>
                        <AccountCircle />
                      </ListItemIcon>
                      <ListItemText primary="Account number:" />
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" color="textSecondary">
                          {selectedAccount.data?.account?.account_number}
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <Schedule />
                      </ListItemIcon>
                      <ListItemText primary="Wallet activation:" />
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" color="textSecondary">
                          {TabUnselected.data?.account?.activation_date}
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <AccountBalance />
                      </ListItemIcon>
                      <ListItemText primary="Current balance:" />
                      <ListItemSecondaryAction>
                        <Typography color="primary">
                          <b>
                            {new Validator().formatMoney(
                              selectedAccount.data?.account?.current_balance
                            )}
                            {selectedAccount.data?.account?.currency_code}
                          </b>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <VpnLock />
                      </ListItemIcon>
                      <ListItemText primary="Account status:" />
                      <ListItemSecondaryAction>
                        <Button
                          color={
                            selectedAccount.data?.account?.status == "ENABLED"
                              ? "primary"
                              : "default"
                          }
                        >
                          {selectedAccount.data?.account?.status}
                        </Button>
                      </ListItemSecondaryAction>
                    </ListItem>
                  </>
                )}
              </List>
            </Grid>
            <Grid item xs={12} lg={8}>
              <Grid container spacing={2}>
                {transactions?.keys?.map((tr, i) => (
                  <Grid item xs={12} sm={6} lg={6}>
                    <Paper elevation={0} className={classes.paper}>
                      <Box width={1}>
                        <Box display="flex" width={1}>
                          <Box flexGrow={1}>
                            <Typography color="textSecondary">
                              {tr.toLowerCase()}
                            </Typography>
                            {/* <Typography color="textSecondary">
                          {transactions?.groups[tr][0].item_name}
                        </Typography> */}
                          </Box>
                          {new Validator().getTransactionIcon(tr)}
                        </Box>
                        <Box
                          mt={1}
                          mb="4px"
                          display="flex"
                          alignItems="flex-end"
                          justifyContent="space-between"
                          width={1}
                        >
                          <Tooltip
                            title={transactions?.groups[tr].length}
                            arrow
                            placement="top"
                          >
                            <Typography variant="h5">
                              {new Validator().formatNumber(
                                transactions?.groups[tr].length
                              )}
                            </Typography>
                          </Tooltip>

                          <Typography color="primary" align="right">
                            {new Validator().formatMoney(
                              new Validator().sum(
                                transactions?.groups[tr],
                                "amount"
                              )
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
              <Box mt={2} />
              {transactions.loading && <LinearProgress />}
              <MUIDataTable
                elevation={0}
                title={
                  "From " +
                  Format(from.value, ["MMMM dd"]) +
                  " to " +
                  Format(to.value, ["MMMM dd"])
                }
                data={transactions.data}
                columns={transactionsColums}
                options={transactionsOptions}
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default withLocalize(WalletDetails);
